export class AgeGenderDistribution{
    id:number;
    values:AgeGenderDistributionValue[];
}

export class AgeGenderDistributionValue{
    value:number;
    ageGenderId:number;
    ageGenderGroupName:string;
}